










































import { Component, Vue } from 'vue-property-decorator';
import UserAlertsService from '@/modules/userAlerts/UserAlertsService';
import notificationService from '@/services/notificationService';
import moment from 'moment';

@Component({
  components: {
  },
})
export default class UserAlertOverviewPage extends Vue {
  private data: IUserAlert[] = [];
  private saving: boolean = false;
  private loading: boolean = true;
  private nextPage: number = 0;
  private pageSize: number = 10;
  private hasNextPage: boolean = true;

  private mounted() {
      this.loadData();
  }

  private async acknowledge(id?: string) {
    try {
      this.saving = true;
      await UserAlertsService.acknowledge(id);

      if (id) {
        const item = this.data.find((o) => o.id === id);
        if (item) {
          item.acknowledgedDate = 'now';
        }
      } else {
          this.data.forEach((item) => {
            item.acknowledgedDate = 'now';
          });
        }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  private async loadData() {
    try {
      this.loading = true;
      const result = (await UserAlertsService.get({
          page: this.nextPage,
          pageSize: this.pageSize,
      })).data;

      result.forEach((element) => {
        this.data.push(element);
      });

      if (result.length !== this.pageSize) {
        this.hasNextPage = false;
      }

      this.nextPage++;
    } catch (err) {
        notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

    private convertDate(item: IUserAlert) {
        return moment(item.moment).format('DD/MM/YYYY HH:mm');
    }
}
